import type {DependencyList, EffectCallback} from 'react';
import { useEffect, useRef} from 'react'
import {useCallbackRef} from './useCallbackRef'

export function useDebouncedEffect(cb: EffectCallback, deps: DependencyList, delay: number) {
    const callbackRef = useCallbackRef(cb)
    const delayRef = useCallbackRef(delay)
    const cancelRef = useRef<void | VoidFn>()

    useEffect(() => {
        const timer = setTimeout(() => {
            cancelRef.current?.()
            cancelRef.current = callbackRef.current()
        }, delayRef.current)
        return () => {
            clearTimeout(timer)
        }
    }, deps)  // eslint-disable-line react-hooks/exhaustive-deps
}
